module.exports = "//public.getcloudapp.com/packs/media/images/icons-new-e01f17c35f718afc7371c81ad668b9b5.svg";